import React from "react";
import MySignatureManager from "../../common/signature/MySignatureManager";

// Ký phiếu cần 1 chữ ký mặc định; nếu chưa có, user tạo ngay tại đây.
const MySignaturePanel = () => (
  <MySignatureManager
    description="Create or upload your default signature. It's embedded on the printed form when you sign a payment request — in the Portal or with Sign now in the approval email."
  />
);

export default MySignaturePanel;
